import { SectionName } from "../../Engine/src/Controls/FormParts/Unit/UnitId/UnitId";

export class SectionNames {
    public static defaultSection = "default" as SectionName;
    public static requisitesSection = "requisites" as SectionName;
}
